import {
    type Path,
    postCheckoutBookClassPath,
    postCheckoutChangeLanguageCheckoutPath,
    postCheckoutChangeLanguageStorePath,
    postCheckoutConfirmLanguagePath,
    postCheckoutCongratulationsPath,
    postCheckoutCreditsTypeSelectionPath,
    postCheckoutLanguagesYouSpeakPath,
    postCheckoutLanguagesYouSpeakThanksPath,
    postCheckoutLearningFocusAreaPath,
    postCheckoutLearningFocusAreaSuccessPath,
    postCheckoutLearningGoalsPath,
    postCheckoutLearningGoalsSuccessPath,
    postCheckoutProficiencyPath,
    postCheckoutSuccessLanguageChangePath,
    postCheckoutTimeSlotsPath,
} from '@lingoda/router';

const F_FREE_TRIAL_POST_CHECKOUT_STEPS: Path[] = [
    postCheckoutProficiencyPath(),
    postCheckoutCreditsTypeSelectionPath(),
];

export const getPostCheckoutSteps = (
    isFFreeTrial: boolean,
    showLanguagePreferencesSteps: boolean,
): Path[] => {
    if (isFFreeTrial) {
        return F_FREE_TRIAL_POST_CHECKOUT_STEPS;
    }

    const languagePreferenceSteps: Path[] = showLanguagePreferencesSteps
        ? [
              postCheckoutConfirmLanguagePath(),
              postCheckoutChangeLanguageStorePath({
                  section: null as never,
                  curriculum: null as never,
              }),
              postCheckoutChangeLanguageCheckoutPath({
                  purchaseId: null as never,
                  section: null as never,
              }),
              postCheckoutSuccessLanguageChangePath(),
          ]
        : [];

    const newOnboardingSurveySteps = [
        postCheckoutLearningGoalsPath(),
        postCheckoutLearningGoalsSuccessPath(),
        postCheckoutLearningFocusAreaPath(),
        postCheckoutLearningFocusAreaSuccessPath(),
        postCheckoutLanguagesYouSpeakPath(),
        postCheckoutLanguagesYouSpeakThanksPath(),
    ];

    return [
        ...languagePreferenceSteps,
        ...newOnboardingSurveySteps,
        postCheckoutLanguagesYouSpeakPath(),
        postCheckoutProficiencyPath(),
        postCheckoutTimeSlotsPath(),
        postCheckoutBookClassPath(),
        postCheckoutCongratulationsPath(),
    ];
};
